/* EdgePro add-to-cart road roller: on submit of the product form, a small
   roller drives across the buy button and flattens the label (CSS runs the
   show; this only toggles the class). Capture phase so it fires even though
   Dawn's product-form.js preventDefaults the same submit event. */
(function () {
  if (window.__epAtcRoller) return;
  window.__epAtcRoller = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var button = form.querySelector('.product-form__submit');
      if (!button || button.disabled || !button.querySelector('.ep-atc-roller')) return;
      button.classList.remove('ep-atc--rolling');
      void button.offsetWidth;
      button.classList.add('ep-atc--rolling');
      window.setTimeout(function () {
        button.classList.remove('ep-atc--rolling');
      }, 1150);
    },
    true
  );
})();
